const mutations = {
    SET_ERROR_BRANDS(state, payload) {
        state.error = payload;
    }
};

export default mutations;
